export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    accountNumber = "",
    entityName = "",
    currencyType = "USD",
    openingBalance = { debitFC: 0, debitVND: 0, creditFC: 0, creditVND: 0 },
    details = [],
    totalIncurred = { debitFC: 0, creditFC: 0, debitVND: 0, creditVND: 0 },
    closingBalance = { debitFC: 0, creditFC: 0, debitVND: 0, creditVND: 0 },
    totalPages = "1",
    openingDate = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    currency = "USD",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  // Rows Construction
  let rowsHtml = `
    <!-- OPENING BALANCE -->
    <tr style="font-weight: bold;">
      <td class="border" rowspan="2"></td>
      <td class="border" rowspan="2"></td>
      <td class="border" rowspan="2"></td>
      <td class="border px-1">- Số dư đầu kỳ</td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border" colspan="4"></td>
      <td class="border text-right px-1">${fmt(openingBalance.debitFC)}</td>
      <td class="border text-right px-1">${fmt(openingBalance.debitVND)}</td>
      <td class="border text-right px-1">${fmt(openingBalance.creditFC)}</td>
      <td class="border text-right px-1">${fmt(openingBalance.creditVND)}</td>
    </tr>
    <tr style="font-weight: bold;">
      <td class="border px-1">- Số phát sinh</td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border" colspan="8"></td>
    </tr>
  `;

  // Details
  details.forEach((item) => {
    rowsHtml += `
      <tr>
        <td class="border text-center">${item.bookingDate || ""}</td>
        <td class="border text-center">${item.documentNumber || ""}</td>
        <td class="border text-center">${item.documentDate || ""}</td>
        <td class="border px-1">${item.description || ""}</td>
        <td class="border text-center">${item.correspondingAccount || ""}</td>
        <td class="border text-center">${item.exchangeRate || ""}</td>
        <td class="border text-center">${item.discountDeadline || ""}</td>
        <td class="border text-right px-1">${fmt(item.debitIncurredFC)}</td>
        <td class="border text-right px-1">${fmt(item.debitIncurredVND)}</td>
        <td class="border text-right px-1">${fmt(item.creditIncurredFC)}</td>
        <td class="border text-right px-1">${fmt(item.creditIncurredVND)}</td>
        <td class="border text-right px-1">${fmt(item.debitBalanceFC)}</td>
        <td class="border text-right px-1">${fmt(item.debitBalanceVND)}</td>
        <td class="border text-right px-1">${fmt(item.creditBalanceFC)}</td>
        <td class="border text-right px-1">${fmt(item.creditBalanceVND)}</td>
      </tr>
    `;
  });

  // Total Incurred
  rowsHtml += `
    <tr style="font-weight: bold;">
      <td class="border" rowspan="2"></td>
      <td class="border" rowspan="2"></td>
      <td class="border" rowspan="2"></td>
      <td class="border px-1">- Cộng số phát sinh</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-right px-1">${fmt(totalIncurred.debitFC)}</td>
      <td class="border text-right px-1">${fmt(totalIncurred.debitVND)}</td>
      <td class="border text-right px-1">${fmt(totalIncurred.creditFC)}</td>
      <td class="border text-right px-1">${fmt(totalIncurred.creditVND)}</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
    </tr>
  `;

  // Closing Balance
  rowsHtml += `
    <tr style="font-weight: bold;" bgcolor="#FAFAFA">
      <td class="border px-1">- Số dư cuối kỳ</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-right px-1">${fmt(closingBalance.debitFC)}</td>
      <td class="border text-right px-1">${fmt(closingBalance.debitVND)}</td>
      <td class="border text-right px-1">${fmt(closingBalance.creditFC)}</td>
      <td class="border text-right px-1">${fmt(closingBalance.creditVND)}</td>
    </tr>
  `;

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 11px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="60%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="40%" align="center">
            <div class="font-bold">Mẫu số S32-DN</div>
            <div style="font-style: italic; font-size: 10px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 15px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 16px;">SỔ CHI TIẾT THANH TOÁN VỚI NGƯỜI MUA (NGƯỜI BÁN) BẰNG NGOẠI TỆ</h2>
        <div style="font-style: italic; font-size: 11px; margin-top: 5px;">(Dùng cho TK: 131, 331)</div>
        
        <div style="margin-top: 10px;">Tài khoản: <span style="font-weight: bold; border-bottom: 1px dotted black; padding: 0 20px;">${accountNumber}</span></div>
        <div style="margin-top: 5px;">Đối tượng: <span style="font-weight: bold; border-bottom: 1px dotted black; padding: 0 40px;">${entityName}</span></div>
        <div style="margin-top: 5px;">Loại ngoại tệ: <span style="font-weight: bold; border-bottom: 1px dotted black; padding: 0 20px;">${currency}</span></div>
      </div>

      <table width="100%" style="border-collapse: collapse; margin-top: 15px;">
        <thead>
          <tr>
            <th class="border" rowspan="3" width="60">Ngày ghi sổ</th>
            <th class="border" colspan="2">Chứng từ</th>
            <th class="border" rowspan="3">Diễn giải</th>
            <th class="border" rowspan="3" width="40">TK đối ứng</th>
            <th class="border" rowspan="3" width="50">Tỷ giá</th>
            <th class="border" rowspan="3" width="60">Thời hạn chiết khấu</th>
            <th class="border" colspan="4">Số phát sinh</th>
            <th class="border" colspan="4">Số dư</th>
          </tr>
          <tr>
            <th class="border" width="50" rowspan="2">Số hiệu</th>
            <th class="border" width="50" rowspan="2">Ngày</th>
            <th class="border" width="60" colspan="2">Nợ</th>
            <th class="border" width="60" colspan="2">Có</th>
            <th class="border" width="60" colspan="2">Nợ</th>
            <th class="border" width="60" colspan="2">Có</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">Ngoại tệ</th>
            <th class="border">VND</th>
            <th class="border">Ngoại tệ</th>
            <th class="border">VND</th>
            <th class="border">Ngoại tệ</th>
            <th class="border">VND</th>
            <th class="border">Ngoại tệ</th>
            <th class="border">VND</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">D</th>
            <th class="border">E</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">4</th>
            <th class="border">5</th>
            <th class="border">6</th>
            <th class="border">7</th>
            <th class="border">8</th>
            <th class="border">9</th>
            <th class="border">10</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
        </tbody>
      </table>

      <div style="margin-top: 20px;">
        <div style="margin-bottom: 5px;">- Sổ này có <span style="border-bottom: 1px dotted black; padding: 0 10px;">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: <span style="border-bottom: 1px dotted black; padding: 0 10px;">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 30px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 10px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 10px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 60px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>
    </div>

    <style>
      .border { border: 1px solid black; }
      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .font-bold { font-weight: bold; }
      .px-1 { padding: 0 4px; }
    </style>
  `;
};
